/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* CUSTOM WRAP */

/* GESTIONE CUSTOM WRAP */
document.addEventListener("DOMContentLoaded", function () {
  

  // Gestione validazione campi messaggio/firma
const messageInput = document.querySelector("#plg-message");
const senderInput = document.querySelector("#plg-sender");
const termsCheckbox = document.querySelector("#terms-checkbox");
const giftWrapCheckbox = document.querySelector("#gift-wrap-checkbox");
const requiredField = document.querySelector("#required-field");
const form = document.querySelector(".ProductForm");
const triggerMoreInfo = document.querySelector("#js-trigger-moreinfo");
const customWrap = document.querySelector(".plg-custom-wrap");

let hasContent = false;
let buyButtonHandler = null; // Per tracciare il listener

// Funzione per gestire il click sul buyButton
function handleBuyButtonClick(e) {
  if (hasContent && termsCheckbox && !termsCheckbox.checked) {
    e.preventDefault();
    e.stopImmediatePropagation();
    requiredField.style.display = "block";
    termsCheckbox.scrollIntoView({ behavior: "smooth", block: "center" });
  }
}

// Gestione apertura/chiusura custom wrap
triggerMoreInfo?.addEventListener("click", () => {
  customWrap.classList.toggle("is-open");
  
  // Cerca il buyButton solo quando si apre il wrap
  const buyButton = document.querySelector("button.ProductForm__AddToCart[type='submit']");
  
  if (buyButton && !buyButtonHandler) {
    // Aggiungi il listener solo se non è già stato aggiunto
    buyButton.addEventListener("click", handleBuyButtonClick);
    buyButtonHandler = true; // Marca come aggiunto
  }
});



  function checkFields() {
    // Verifica se almeno uno dei campi è compilato
    const messageHasValue = messageInput && messageInput.value.trim() !== "";
    const senderHasValue = senderInput && senderInput.value.trim() !== "";
    hasContent = messageHasValue || senderHasValue;

    if (hasContent) {
        
      if (giftWrapCheckbox) {
        giftWrapCheckbox.checked = true;
        giftWrapCheckbox.classList.add("is-locked");
      }
      if (termsCheckbox && termsCheckbox.checked) {
        requiredField.style.display = "none";
      } else {
        requiredField.style.display = "block";
      }
    } else {
      if (giftWrapCheckbox) {
        giftWrapCheckbox.classList.remove("is-locked");
      }
      requiredField.style.display = "none";
    }
  }

  // Previeni la deselezione quando è locked
  if (giftWrapCheckbox) {
    giftWrapCheckbox.addEventListener("click", function (e) {
      if (this.classList.contains("is-locked") && !this.checked) {
        e.preventDefault();
        this.checked = true;
      }
    });
  }

  


  // Ascolta i cambiamenti sui campi
  if (messageInput) {
    messageInput.addEventListener("input", checkFields);
  }

  if (senderInput) {
    senderInput.addEventListener("input", checkFields);
  }

  if (termsCheckbox) {
    termsCheckbox.addEventListener("change", checkFields);
  }

  // Check iniziale
  checkFields();
});

document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver((mutations, obs) => {
    const buyButton = document.querySelector("button.ProductForm__AddToCart[type='submit']");
    if (buyButton) {
      buyButton.addEventListener("mouseenter", () => {
        console.log("test");
      });
      obs.disconnect(); // smette di osservare una volta trovato il pulsante
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});


/* DRAWER */

/* GESTIONE T&C DRAWER */
document.addEventListener("DOMContentLoaded", function () {
  
  // Usa event delegation sul documento
  document.body.addEventListener("input", function(e) {
    if (e.target.classList.contains("plg-drawer-firma") || 
        e.target.classList.contains("plg-drawer-messaggio")) {
      
      checkDrawerFields();
    }
  });

  document.body.addEventListener("change", function(e) {
    if (e.target.classList.contains("plg-drawer-firma") || 
        e.target.classList.contains("plg-drawer-messaggio")) {
      
      checkDrawerFields();
    }
  });

  function checkDrawerFields() {
    const firmaDrawer = document.querySelector(".plg-drawer-firma");
    const noteDrawer = document.querySelector(".plg-drawer-messaggio");
    const termsCheckboxWrapper = document.querySelector("#terms-message-wrapper");
    const termsCheckbox = document.querySelector("#terms-checkbox-drawer");

    if (!firmaDrawer || !noteDrawer || !termsCheckboxWrapper || !termsCheckbox) {
      return;
    }

    const messageHasValue = noteDrawer.value.trim() !== "";
    const senderHasValue = firmaDrawer.value.trim() !== "";
    const hasContent = messageHasValue || senderHasValue;
    

    if (hasContent) {
      termsCheckboxWrapper.style.display = "block";
      termsCheckbox.required = true;
    } else {
      termsCheckboxWrapper.style.display = "none";
      termsCheckbox.required = false;
    }
  }

  // Check iniziale quando il drawer diventa visibile
  const observer = new MutationObserver(checkDrawerFields);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

/* CART CUSTOM ATTRIBUTE - Salvataggio automatico messaggio personalizzato */
/* CART CUSTOM ATTRIBUTE - Salvataggio automatico messaggio personalizzato e sincronizzazione */
/* CART CUSTOM ATTRIBUTE - Salvataggio automatico, Sincronizzazione e Logica T&C */
/* CART CUSTOM ATTRIBUTE - Salvataggio automatico, Sincronizzazione e Logica T&C */
/* CART CUSTOM ATTRIBUTE - Salvataggio automatico, Sincronizzazione e Logica T&C (Versione Finale) */
/* CART CUSTOM ATTRIBUTE - Salvataggio automatico, Sincronizzazione e Logica T&C (SOLUZIONE DEFINITIVA) */
document.addEventListener("DOMContentLoaded", function () {
  
  // Funzione di debounce per limitare la frequenza delle chiamate API
  const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func.apply(this, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  // Funzione per trovare tutti i campi di input degli attributi e della nota in entrambi i contesti
  function getCartNoteFields() {
    const customMessageName = "attributes[messaggio_personalizzato_ordine]";
    const customSignatureName = "attributes[firma_personalizzato_ordine]";
    
    // Seleziona tutti i campi che hanno i nomi degli attributi o il nome della nota
    const allFields = document.querySelectorAll(
      `[name="${customMessageName}"], 
       [name="${customSignatureName}"], 
       [name="note"]`
    );
    
    return Array.from(allFields);
  }
  
  // Funzione per trovare le checkbox di T&C
  function getTCCheckboxes() {
    return document.querySelectorAll('#terms-checkbox, #terms-checkbox-drawer');
  }

  // Sincronizza il valore di un campo su tutti i campi con lo stesso attributo 'name'
  function syncAttributeFields(attributeName, value, excludeElement) {
    const allFields = document.querySelectorAll(`[name="${attributeName}"]`);

    allFields.forEach((field) => {
      if (field !== excludeElement && field.value !== value) {
        field.value = value;
        
        // Forza il dispatch degli eventi per assicurare che gli altri listener (T&C, ecc.) reagiscano.
        field.dispatchEvent(new Event('input', { bubbles: true })); 
        field.dispatchEvent(new Event('change', { bubbles: true })); 
      }
    });
  }
  
  // Controlla se il messaggio/firma personalizzato ha contenuto e imposta il requisito T&C
  function checkCartFields() {
    const customMessageName = "attributes[messaggio_personalizzato_ordine]";
    const customSignatureName = "attributes[firma_personalizzato_ordine]";
    
    const messageFields = document.querySelectorAll(`[name="${customMessageName}"]`);
    const signatureFields = document.querySelectorAll(`[name="${customSignatureName}"]`);
    const tCFields = getTCCheckboxes();

    let hasContent = false;

    // Controlla se almeno uno dei campi ha contenuto
    [...messageFields, ...signatureFields].forEach(field => {
      if (field.value && field.value.trim() !== "") {
        hasContent = true;
      }
    });

    tCFields.forEach((checkbox) => {
      checkbox.required = hasContent;
      
      // Gestisce la visibilità del wrapper della checkbox nel drawer
      if (checkbox.id === 'terms-checkbox-drawer') {
        const wrapper = document.getElementById('terms-message-wrapper');
        if (wrapper) {
          wrapper.style.display = hasContent ? '' : 'none'; 
        }
      }

      if (!hasContent) {
        checkbox.setCustomValidity("");
      }
    });
  }


  // Gestisce il salvataggio automatico degli attributi e della nota
  const throttledUpdate = debounce(function(event) {
    const target = event.target;
    const name = target.getAttribute("name");

    if (!name) return;
    
    checkCartFields();

    // 1. Gestisce le note standard
    if (name === "note") {
      fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: target.value }),
        keepalive: true,
      });
      syncAttributeFields(name, target.value, target);
    }
    // 2. Gestisce gli attributi personalizzati
    else if (name.startsWith("attributes[")) {
      const attributeName = name.match(/attributes\[(.*?)\]/)?.[1];

      if (attributeName) {
        const attributes = {};
        attributes[attributeName] = target.value;

        fetch(`${Shopify.routes.root}cart/update.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes }),
          keepalive: true,
        })
          .then(() => {
            // Sincronizza tra i campi SOLO DOPO il salvataggio API
            syncAttributeFields(name, target.value, target); 
          })
          .catch((error) => {
            console.error("Errore nel salvataggio dell'attributo:", error);
          });
      }
    }
  }, 500); // Debounce a 500ms

  
  // Funzione per inizializzare o reinizializzare tutti i listener
  function initializeCartListeners() {
    getCartNoteFields().forEach((field) => {
      // 1. Rimuovi listener precedenti (importante dopo AJAX)
      field.removeEventListener("change", throttledUpdate);
      field.removeEventListener("input", throttledUpdate);
      field.removeEventListener("input", checkCartFields);
      field.removeEventListener("change", checkCartFields);

      // 2. Aggiungi i listener
      field.addEventListener("change", throttledUpdate);
      field.addEventListener("input", throttledUpdate);
      
      // Aggiungi listener per la logica T&C (chiamata anche da throttledUpdate)
      const name = field.getAttribute('name');
      if (name.startsWith("attributes[")) {
        field.addEventListener("input", checkCartFields);
        field.addEventListener("change", checkCartFields);
      }
    });

    // 3. Esegui il controllo iniziale per T&C
    checkCartFields();
  }
  
  
  // --- Gestione Carrello Drawer (Prestige Theme) ---

  // Inizializzazione iniziale
  initializeCartListeners();

  // Aggiungiamo un listener all'elemento principale del carrello/drawer 
  // che, quando modificato (dall'AJAX del tema), ri-inizializza i listener.
  // Usiamo il selettore più generale possibile che avvolge il contenuto del carrello
  const cartContainer = document.querySelector('[data-section-type="cart"]'); 

  if (cartContainer) {
    const observerConfig = { childList: true, subtree: true, attributes: false };
    
    const cartObserver = new MutationObserver(function(mutationsList, observer) {
        let needsReinitialization = false;

        for(const mutation of mutationsList) {
            // Controlliamo se ci sono nodi aggiunti/rimossi o cambiamenti di testo nel carrello
            // Questo cattura il rimpiazzo completo del contenuto del carrello che fa il tema.
            if (mutation.type === 'childList' && mutation.target.closest('.Cart')) {
                needsReinitialization = true;
                break;
            }
        }

        if (needsReinitialization) {
            // Diamo un piccolo ritardo per assicurarci che il DOM del tema sia completamente assestato
            setTimeout(initializeCartListeners, 50); 
        }
    });

    cartObserver.observe(cartContainer, observerConfig);
    
    // Assicuriamoci che i listener vengano riattivati anche tramite eventi espliciti, 
    // nel caso in cui il tema ne usi uno.
    document.addEventListener('cart:refresh', initializeCartListeners);
    document.addEventListener('shopify:section:load', initializeCartListeners);
  }
});

/* PRODUCT PAGE DETAIL */
/* GESTIONE DESCRIZIONE LEGGI DI PIÙ */
window.addEventListener("load", () => {
const productDescription = document.querySelector(".js-product-description");
const productShowMore = document.querySelector(".js-show-more");
if (productDescription && productShowMore) {
  const labelMore = productShowMore.dataset.labelMore;
  const labelLess = productShowMore.dataset.labelLess;

  if (productDescription.scrollHeight <= productDescription.clientHeight) {
    productShowMore.style.display = "none";
  }
  productShowMore.addEventListener("click", () => {
    productDescription.classList.toggle("clamp-description");
    productShowMore.textContent = !productDescription.classList.contains(
      "clamp-description"
    )
      ? labelLess
      : labelMore;
  });
}

});